"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    align-items: center;\n    justify-content: space-between;\n    position: relative;\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var base = function base(_ref) {
  var theme = _ref.theme,
      selected = _ref.selected,
      disabled = _ref.disabled;
  return {
    fontSize: theme.fontSize,
    lineHeight: theme.lineHeight,
    color: disabled ? theme.disabledColor : selected ? theme.selectedColor : theme.color,
    fontWeight: theme.fontWeight,
    display: theme.display,
    width: theme.width,
    minWidth: theme.minWidth,
    // issuer icon is scaled from 28px. it gives incorrect line-height
    height: theme.palette.gutter * 3 + 'px'
  };
};

var Root = _styledComponents["default"].div(_templateObject(), function (props) {
  return base(props);
});

var _default = Root;
exports["default"] = _default;